"use strict";
{
    setTimeout(() => {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            initMegaMenu();
        } else {
            document.addEventListener('DOMContentLoaded', () => {
                initMegaMenu();
            }, {
                once: true,
            });
        }
    }, 0);


    const initMegaMenu = () => {

        
        const megaMenus = document.querySelectorAll('[data-mega-menu]');
        megaMenus.forEach(megaMenu => {

            let selectedLink;
            const megaMenuMediaLinks = megaMenu.querySelectorAll('[data-mega-menu-link]');
            const megaMenuMediaContainers = megaMenu.querySelectorAll('[data-mega-menu-media-container]');

            new MegaMenuMedia({ selectedLink: selectedLink, links: megaMenuMediaLinks, containers: megaMenuMediaContainers })

        });
    }


    class MegaMenuMedia {
        constructor({ selectedLink, links, containers }) {
            this.links = links
            this.containers = containers


            this.eventlisterners();
        }


        eventlisterners() {

            this.links.forEach(link => {
                link.addEventListener('mouseover', () => {
                    this.setSelected({ selectedLink: link });
                })
            });

        }

        setSelected({ selectedLink }) {
            let selectedContainer;

            this.links.forEach((link) => {
                link.classList.remove('selected');
            });
            selectedLink.classList.add('selected');

            this.containers.forEach((container) => {

                if (selectedLink.dataset.megaMenuMediaId != undefined && selectedLink.dataset.megaMenuMediaId == container.dataset.megaMenuMediaId) {
                    selectedContainer = container;
                }

                container.classList.add('visually-hidden');
            });

            if(!selectedContainer) return;

            selectedContainer.classList.remove('visually-hidden');
        }
    }

}